// University of Connecticut's bachelor's majors (#2839). Read on 2026-10-01
// from UConn's official 2026-2027 Undergraduate Catalog (catalog.uconn.edu,
// "2026-2027 Edition"): every program the catalog lists under each school or
// college, with the degree in the catalog's own parentheses (BS, BA, BSE,
// BFA, BM, BGS, BSW, IB/M; "BA or BS" where the catalog offers both). Left
// out: minors, certificates, the Ratcliffe Hicks School of Agriculture's
// associate degrees, accelerated bachelor's/master's pairings, and the
// Pharm.D. The catalog lists Management and Engineering for Manufacturing
// under both Business and Engineering; it appears once here, under the
// School of Business, with a note. Environmental Sciences and Environmental
// Studies are separate majors in both CAHNR and CLAS, so each appears under
// both. Names drop the catalog's "CAHNR"/"CLAS" suffixes and its invisible
// zero-width spaces. The Neag School and School of Social Work programs
// start in the junior year, as their group notes say.
const majors = {
    "slug": "university-of-connecticut",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in UConn's official 2026-2027 Undergraduate Catalog, grouped by the school or college that offers it, with the degree it leads to. Minors, certificates, associate degrees and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agriculture, Health and Natural Resources",
            "source": {
                "label": "UConn 2026-2027 Undergraduate Catalog, College of Agriculture, Health and Natural Resources",
                "url": "https://catalog.uconn.edu/undergraduate/agriculture-health-natural-resources/"
            },
            "majors": [
                {
                    "name": "Agriculture, Health and Natural Resources",
                    "degree": "BS"
                },
                {
                    "name": "Allied Health Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Animal Science",
                    "degree": "BS"
                },
                {
                    "name": "Diagnostic Genetic Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Dietetics",
                    "degree": "BS"
                },
                {
                    "name": "Economics of Sustainable Development and Management",
                    "degree": "BS"
                },
                {
                    "name": "Environmental and Natural Resource Economics",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Equine Science and Management",
                    "degree": "BS"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Individualized Major",
                    "degree": "BS"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BS"
                },
                {
                    "name": "Medical Laboratory Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Natural Resources",
                    "degree": "BS"
                },
                {
                    "name": "Nutritional Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Pathobiology",
                    "degree": "BS"
                },
                {
                    "name": "Plant Science",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Business",
            "source": {
                "label": "UConn 2026-2027 Undergraduate Catalog, School of Business",
                "url": "https://catalog.uconn.edu/undergraduate/business/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Analytics and Information Management",
                    "degree": "BS"
                },
                {
                    "name": "Business Administration",
                    "degree": "BS"
                },
                {
                    "name": "Business Data Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "Financial Management",
                    "degree": "BS"
                },
                {
                    "name": "Health Care Management",
                    "degree": "BS"
                },
                {
                    "name": "Management",
                    "degree": "BS"
                },
                {
                    "name": "Management and Engineering for Manufacturing",
                    "degree": "BS",
                    "note": "Offered jointly with the College of Engineering."
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Marketing Management",
                    "degree": "BS"
                },
                {
                    "name": "Real Estate and Urban Economic Studies",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "UConn 2026-2027 Undergraduate Catalog, College of Engineering",
                "url": "https://catalog.uconn.edu/undergraduate/engineering/"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science and Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Data Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Engineering Physics",
                    "degree": "BSE"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Multidisciplinary Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Robotics Engineering",
                    "degree": "BSE"
                }
            ]
        },
        {
            "name": "School of Fine Arts",
            "source": {
                "label": "UConn 2026-2027 Undergraduate Catalog, School of Fine Arts",
                "url": "https://catalog.uconn.edu/undergraduate/fine-arts/"
            },
            "majors": [
                {
                    "name": "Acting",
                    "degree": "BFA"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Design and Technical Theatre",
                    "degree": "BFA"
                },
                {
                    "name": "Digital Media Design",
                    "degree": "BA"
                },
                {
                    "name": "Digital Media Design",
                    "degree": "BFA"
                },
                {
                    "name": "Jazz Studies",
                    "degree": "BM"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BM"
                },
                {
                    "name": "Puppet Arts",
                    "degree": "BFA"
                },
                {
                    "name": "Theatre Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Liberal Arts and Sciences",
            "source": {
                "label": "UConn 2026-2027 Undergraduate Catalog, College of Liberal Arts and Sciences",
                "url": "https://catalog.uconn.edu/undergraduate/liberal-arts-sciences/"
            },
            "majors": [
                {
                    "name": "Africana Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Sign Language Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Applied Data Analysis",
                    "degree": "BA"
                },
                {
                    "name": "Arabic and Islamic Civilizations",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BA or BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA or BS"
                },
                {
                    "name": "Chinese",
                    "degree": "BA"
                },
                {
                    "name": "Classics and Ancient Mediterranean Studies",
                    "degree": "BA"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BA or BS"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Earth Sciences",
                    "degree": "BA or BS"
                },
                {
                    "name": "Ecology and Evolutionary Biology",
                    "degree": "BA or BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA or BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "BA"
                },
                {
                    "name": "General Studies",
                    "degree": "BGS"
                },
                {
                    "name": "Geographic Information Science",
                    "degree": "BA or BS"
                },
                {
                    "name": "Geography",
                    "degree": "BA or BS"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Human Development and Family Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Human Rights",
                    "degree": "BA"
                },
                {
                    "name": "Individualized",
                    "degree": "BA or BS"
                },
                {
                    "name": "Italian Literary and Cultural Studies",
                    "degree": "BA"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Judaic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latino and Latin American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Marine Sciences",
                    "degree": "BA or BS"
                },
                {
                    "name": "Maritime Studies",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA or BS"
                },
                {
                    "name": "Mathematics-Actuarial Science",
                    "degree": "BA or BS"
                },
                {
                    "name": "Mathematics-Actuarial Science-Finance",
                    "degree": "BA or BS"
                },
                {
                    "name": "Mathematics-Physics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics-Statistics",
                    "degree": "BA or BS"
                },
                {
                    "name": "Molecular and Cell Biology",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA or BS"
                },
                {
                    "name": "Physiology and Neurobiology",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychological Sciences",
                    "degree": "BA or BS"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Speech, Language and Hearing Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Statistical Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Statistics",
                    "degree": "BA or BS"
                },
                {
                    "name": "Structural Biology and Biophysics",
                    "degree": "BS"
                },
                {
                    "name": "Urban and Community Studies",
                    "degree": "BA"
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Neag School of Education",
            "source": {
                "label": "UConn 2026-2027 Undergraduate Catalog, Neag School of Education",
                "url": "https://catalog.uconn.edu/undergraduate/neag-education/"
            },
            "note": "The teacher education programs are Integrated Bachelor's/Master's (IB/M) programs of five years: two years of study in another school or college, two in the Neag School's undergraduate program, and a fifth year in the Graduate School for a master's degree.",
            "majors": [
                {
                    "name": "American Sign Language Education (Grades 4-12)",
                    "degree": "IB/M"
                },
                {
                    "name": "Biology Education (Grades 4-12)",
                    "degree": "IB/M"
                },
                {
                    "name": "Chemistry Education (Grades 4-12)",
                    "degree": "IB/M"
                },
                {
                    "name": "Comprehensive Special Education (Grades PK-12)",
                    "degree": "IB/M"
                },
                {
                    "name": "Earth Science Education (Grades 4-12)",
                    "degree": "IB/M"
                },
                {
                    "name": "Elementary Education (Grades PK-6)",
                    "degree": "IB/M"
                },
                {
                    "name": "English Education (Grades 4-12)",
                    "degree": "IB/M"
                },
                {
                    "name": "French Language Education (Grades 4-12)",
                    "degree": "IB/M"
                },
                {
                    "name": "General Science Education (Grades 4-12)",
                    "degree": "IB/M"
                },
                {
                    "name": "German Language Education (Grades 4-12)",
                    "degree": "IB/M"
                },
                {
                    "name": "History and Social Studies Education (Grades 4-12)",
                    "degree": "IB/M"
                },
                {
                    "name": "Italian Language Education (Grades 4-12)",
                    "degree": "IB/M"
                },
                {
                    "name": "Latin/Classics Language Education (Grades 4-12)",
                    "degree": "IB/M"
                },
                {
                    "name": "Mandarin Chinese Language Education (Grades 4-12)",
                    "degree": "IB/M"
                },
                {
                    "name": "Mathematics Education (Grades 4-12)",
                    "degree": "IB/M"
                },
                {
                    "name": "Music Education (Grades PK-12)",
                    "degree": "IB/M"
                },
                {
                    "name": "Physics Education (Grades 4-12)",
                    "degree": "IB/M"
                },
                {
                    "name": "Spanish Language Education (Grades 4-12)",
                    "degree": "IB/M"
                },
                {
                    "name": "Sport Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Elisabeth DeLuca School of Nursing",
            "source": {
                "label": "UConn 2026-2027 Undergraduate Catalog, Elisabeth DeLuca School of Nursing",
                "url": "https://catalog.uconn.edu/undergraduate/nursing/"
            },
            "majors": [
                {
                    "name": "Nursing (Accelerated Career Entry into Nursing)",
                    "degree": "BS",
                    "note": "A one-year track for students who already hold a bachelor's degree in another field."
                },
                {
                    "name": "Nursing",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Pharmacy and Pharmaceutical Sciences",
            "source": {
                "label": "UConn 2026-2027 Undergraduate Catalog, School of Pharmacy and Pharmaceutical Sciences",
                "url": "https://catalog.uconn.edu/undergraduate/pharmacy/"
            },
            "note": "The B.S. in Pharmacy Studies follows two pre-professional years and is part of the B.S./Pharm.D. professional program; the Pharm.D. that follows is a doctoral degree and is not listed.",
            "majors": [
                {
                    "name": "Pharmacy Studies",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Social Work",
            "source": {
                "label": "UConn 2026-2027 Undergraduate Catalog, School of Social Work",
                "url": "https://catalog.uconn.edu/undergraduate/social-work/"
            },
            "note": "Students enter the School of Social Work in the junior year, after two or more years in another school or college.",
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "BSW",
                    "note": "Completed on the Hartford campus."
                }
            ]
        }
    ]
};

export default majors;
